import { objectJoin } from "./objectJoin.js";
import { Type } from "../type/Type.js";
/**
 * Applies defaults to an original object
 * @param original the original object
 * @param defaults defaults to apply to original
 * @param returnCopy whether to return a copy of original with updates applied or to update the orignial object itself when applying defaults
 * @returns an object with defaults applied to original
 */
export function objectApplyDefaults(original, defaults, returnCopy = false) {
    if (returnCopy) {
        const defaultsClone = Type.clone(defaults); // clone defaults so we don't have accidental cross references between the originally passed defaults and the returned value here
        return objectJoin(defaultsClone, original, 'merge', true); // we clone assignments here so any sub-objects in "original" aren't copied by reference (else changes to the new object could affect original)
    }
    return objectJoin(original, defaults, 'append', true); // we clone assignments here so any sub-objects in "defaults" aren't copied by reference (else changes to the new object could affect defaults)
}
//# sourceMappingURL=objectApplyDefaults.js.map